import {useCallback, useMemo, useState} from "react";
import {getStoredPageSize} from "./storage";

const initialState = {pageIndex: 0, pageSize: 15}


const useDataTablePagination = (props = {}) => {
    const { dataTableId, entriesPerPage } = props;
    const defaultPageSize = entriesPerPage?.defaultValue ?? initialState.pageSize;
    
    const [pagination, setPaginationState] = useState(() => ({
        pageIndex: 0,
        pageSize: getStoredPageSize(dataTableId, defaultPageSize)
    }));

    const {pageIndex, pageSize} = pagination;

    const setPagination = useCallback((updater) => {
        setPaginationState((old) => {
            const next = typeof updater === 'function' ? updater(old) : updater;
            return next;
        });
    }, []);

    const goToFirstPage = useCallback(() => {
        setPagination((prev) => ({...prev, pageIndex: 0}))
    }, [setPagination]);

    const resetPagination = useCallback(() => {
        setPaginationState({
            pageIndex: 0,
            pageSize: getStoredPageSize(dataTableId, defaultPageSize)
        })
    }, [dataTableId, defaultPageSize])

    const paginationFetchOptions = useMemo(() => ({
        pageIndex,
        pageSize
    }), [pageIndex, pageSize]);


    return {
        goToFirstPage,
        pagination,
        paginationFetchOptions,
        setPagination,
        resetPagination
    }
}

export default useDataTablePagination;
